import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormDomainScriptGuideHeatmapsService } from './service/heatmaps.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'form-domain-script-guide-features-heatmaps',
    standalone: false,
    templateUrl: './heatmaps.component.html',
})
export class FormDomainScriptGuideFeaturesHeatmapsComponent implements OnInit, OnDestroy {
    @Input() prefixName?: string;
    show: boolean = false;
    canUse: boolean = false;
    private subscription?: Subscription;

    constructor (
        private formDomainScriptGuideHeatmapsService: FormDomainScriptGuideHeatmapsService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    ngOnDestroy () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    activate () {
        this.prefixName = this.prefixName || '';
        this.show = this.formDomainScriptGuideHeatmapsService.hasAccessToFeature();
        this.canUse = this.formDomainScriptGuideHeatmapsService.getValue();
        this.setupWatcher();
    }

    onChangeValue () {
        setTimeout(() => {
            this.setValue(this.canUse);
        });
    }

    // PROTECTED
    private setupWatcher () {
        this.subscription = this.formDomainScriptGuideHeatmapsService.settingChangeObs.subscribe(() => {
            this.canUse = this.formDomainScriptGuideHeatmapsService.getValue();
        });
    }

    private setValue (value: boolean) {
        this.formDomainScriptGuideHeatmapsService.setValue(value, true);
    }
}
